export enum UserDomain {
    SDSG = 1,
    CPE,
    CSS,
    DS
}
